import { useEffect, useState } from 'react';
import { useAuth } from '../Context/AuthProvider';
import { Navigate, Outlet } from 'react-router-dom';
import { validateToken } from '../http/api';

const ProtectedRoute = () => {
  const { isLoggedIn, token, logout } = useAuth();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const check = async () => {
      if (isLoggedIn && token) {
        const valid = await validateToken(token);
        if (!valid) {
          logout();
        }
      }else{
        logout(); 
      }
      setChecking(false);
    };
    check();
  }, [isLoggedIn, token, logout]);

  if (checking) return null;
  if (!isLoggedIn) return <Navigate to="/login" />;
  return <Outlet />;
};

export default ProtectedRoute;